export const eLearningModalMethods = {
	methods: {
		infoModalAction(action) {
			switch (action) {
				case 'courses':
					this.$store.commit('setLearningModal', false);
					this.$cookies.set('learningInformation', '1', '7d');
					break;
				case 'exit':
					this.$store.commit('setLearningModal', false);
					this.$cookies.set('learningInformation', '1', '7d');
					break;
				case 'more':
					window.open(
						'https://www.mforex.pl/interwencja-produktowa-knf',
						'_blank'
					);
					break;
			}
		},
		exitModalAction(action) {
			if (action === 'exit') {
				if (this.videoSection && !this.leavePage) {
					const now = new Date();
					let selectedVideo = this.$store.getters.getTemporaryVideo;

					const expirationDate = new Date(
						now.getTime() + this.$store.getters.getTimeToLogout
					);
					sessionStorage.setItem('expirationDate', expirationDate);

					this.$store.dispatch(
						'fetchLogOutTimer',
						this.$store.getters.getTimeToLogout
					);
					this.$store.commit('setSelectedVideo', selectedVideo);
					this.$store.dispatch('generateToken');
				} else {
					this.$store.commit('setChangePath', true);
					let path =
						this.changePath === '/'
							? '/Dashboard'
							: this.changePath;
					this.$router.push(path);
				}
				this.$store.commit('setLearningModal', false);
			} else {
				this.$store.commit('setLearningModal', false);
			}
		},

		leaveQuiz() {
			this.$store.commit('setChangePath', false);
			this.$store.commit('setLearningModal', false);
		},

		timeIsOverAction(action) {
			this.$store.commit('setChangePath', true);
			this.$store.commit('setLearningModal', false);
			this.$store.commit('setTimeIsOverModal', false);
			if (action === 'stay') {
				this.$store.dispatch('sendAnwsers');
			} else {
				let path = '/Dashboard';
				this.$router.push(path);
			}
		},
	},
};
